export const EXCLUSIVE_VIDEOS_REQUEST = "EXCLUSIVE_VIDEOS_REQUEST";
export const EXCLUSIVE_VIDEOS_RECEIVE = "EXCLUSIVE_VIDEOS_RECEIVE";
